var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "New Package",
        label: "Create",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-4 overflow-y-auto",
          style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
        },
        [
          _c(
            "div",
            { staticClass: "px-8 flex flex-col gap-4" },
            [
              _c("BlInputText", {
                attrs: { input: _vm.nameInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c("BlInputText", {
                attrs: { input: _vm.descriptionInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col gap-2" },
                [
                  _c("BlTextSubtitle1", {
                    attrs: { text: "Add package items" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "text-slate-700",
                    attrs: { text: "You can add multiple items to a package." }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "py-2 px-4 grid grid-cols-3 gap-4 bg-slate-100 rounded border border-slate-300"
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center flex-col gap-1" },
                    [
                      _c("BlTextSubtitle1", {
                        attrs: { text: _vm.totalItems }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Total items" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center flex-col gap-1" },
                    [
                      _c("BlTextSubtitle1", {
                        attrs: { text: _vm.totalCredits }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Total credits" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center flex-col gap-1" },
                    [
                      _c(
                        "div",
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: _vm.currentCenter.currency_sym }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle1", {
                            attrs: { text: _vm.priceFormats(_vm.totalPrice) }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Total price" }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.packageServicesInput, function(item, idx) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass:
                      "py-4 px-4 flex flex-col gap-4 bg-slate-100 rounded border border-slate-300"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-end gap-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex-grow" },
                          [
                            _c("BlSelectBox", {
                              attrs: {
                                label: "Item",
                                asterisk: "",
                                placeholder: "Select item",
                                options: _vm.creditPackageItemOptions
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChangeService(idx, $event)
                                }
                              },
                              model: {
                                value:
                                  _vm.packageServicesInput[idx].package_item_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.packageServicesInput[idx],
                                    "package_item_id",
                                    $$v
                                  )
                                },
                                expression:
                                  "packageServicesInput[idx].package_item_id"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: {
                            type: "plain",
                            icon: "delete",
                            disabled: _vm.totalItems < 2
                          },
                          on: {
                            clicked: function($event) {
                              return _vm.onRemoveService(item.id)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "py-3 px-4 flex items-center flex-col gap-1 bg-slate-300 rounded"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-3" },
                          [
                            _c("BlInputButton", {
                              staticClass: "rounded-full",
                              attrs: {
                                type: "outlined",
                                icon: "minus",
                                dense: "",
                                disabled:
                                  _vm.packageServicesInput[idx]
                                    .session_credit <= 0
                              },
                              on: {
                                clicked: function($event) {
                                  return _vm.onInputCredits(
                                    idx,
                                    _vm.packageServicesInput[idx]
                                      .session_credit - 1,
                                    item.standard_retail_price
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "outline-none w-104 h-20 flex items-center justify-center rounded border border-slate-500 text-center text-6xl font-bold text-dark-purple-100 focus:border-light-purple",
                              class: [
                                _vm.packageServicesInput[idx].session_credit <=
                                0
                                  ? "text-error-300"
                                  : "text-dark-purple-100"
                              ],
                              attrs: {
                                type: "number",
                                name: "credit_count_" + item.id,
                                id: "credit_count_" + item.id,
                                min: 1
                              },
                              domProps: {
                                value:
                                  _vm.packageServicesInput[idx].session_credit
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInputCredits(
                                    idx,
                                    $event.target.value,
                                    item.standard_retail_price
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("BlInputButton", {
                              staticClass: "rounded-full",
                              attrs: {
                                type: "outlined",
                                icon: "plus",
                                dense: ""
                              },
                              on: {
                                clicked: function($event) {
                                  return _vm.onInputCredits(
                                    idx,
                                    _vm.packageServicesInput[idx]
                                      .session_credit + 1,
                                    item.standard_retail_price
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Credits" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlInputText", {
                          attrs: {
                            input: {
                              label: "Standard retail price",
                              disabled: true,
                              model: _vm.priceFormats(
                                item.standard_retail_price
                              ),
                              prefix: _vm.currentCenter.currency_sym,
                              prefixSpace: "3rem"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-6" },
                          [
                            _c("BlIcon", {
                              staticClass: "h-6 w-6",
                              attrs: {
                                icon: "horizontal-arrow",
                                color: "slate-6"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlInputText", {
                          attrs: {
                            input: {
                              label: "Total price",
                              inputType: "number",
                              min: 0,
                              model: _vm.packageServicesInput[idx].total_price,
                              prefix: _vm.currentCenter.currency_sym,
                              prefixSpace: "3rem"
                            }
                          },
                          on: {
                            changed: function($event) {
                              return _vm.onInputTotalPrice(idx, $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  type: "outlined",
                  dense: "",
                  label: "Add another item"
                },
                on: { clicked: _vm.onAddAnotherService }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-full h-5 flex-shrink-0 bg-grey-100" }),
          _vm._v(" "),
          _c("div", { staticClass: "px-8 flex flex-col gap-4" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-2" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.setExpirationDateInput = !_vm.setExpirationDateInput
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pl-2 pr-4",
                        style: { transform: "scale(1.375)" }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.setExpirationDateInput },
                          on: {
                            changed: function($event) {
                              _vm.setExpirationDateInput = !_vm.setExpirationDateInput
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextSubtitle1", {
                      attrs: { text: "Set expiration date" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "The expiration date determines the last day credits can be used to book an appointment—unused credits will be lost after this date, but booked appointments remain valid even if they occur later."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.setExpirationDateInput
              ? _c(
                  "div",
                  { staticClass: "grid grid-cols-2 gap-2" },
                  [
                    _c("BlInputText", {
                      attrs: { input: _vm.expirationDaysInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full h-5 flex-shrink-0 bg-grey-100" }),
          _vm._v(" "),
          _c("div", { staticClass: "px-8 flex flex-col gap-4" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-2" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.setMaximumRescheduleInput = !_vm.setMaximumRescheduleInput
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pl-2 pr-4",
                        style: { transform: "scale(1.375)" }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.setMaximumRescheduleInput },
                          on: {
                            changed: function($event) {
                              _vm.setMaximumRescheduleInput = !_vm.setMaximumRescheduleInput
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextSubtitle1", {
                      attrs: { text: "Set maximum reschedules" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "If the reschedule limit is not specified, sessions using this credit can be rescheduled infinitely."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.setMaximumRescheduleInput
              ? _c(
                  "div",
                  { staticClass: "grid grid-cols-2 gap-2" },
                  [
                    _c("BlInputText", {
                      attrs: { input: _vm.maximumRescheduleInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08077798", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08077798","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/package/NewPackageModal.vue
// module id = null
// module chunks = 